import React from 'react';
import SectionContainer from '../../../common/SectionContainer';
import FieldRow from '../../../common/FieldRow';
import { r18 as r18Fn } from '../formulas';

const R18Section = ({ data, computed }) => {
  return (
    <SectionContainer title="Recuadro N° 18" subtitle="Determinación del RAI (Art. 14 letra D) N° 3 LIR)">
      <div className="f22-subsection">
        <FieldRow label="CPTS positivo final (recuadro N° 19)" code="1703" sign="(+)" value={r18Fn.cptsPositivo(data)} computed />
        <FieldRow label="Remesas, retiros o dividendos repartidos, históricos" code="1704" sign="(+)" value={r18Fn.retirosHistoricos(data)} computed />
        <FieldRow label="Subtotal" code="1720" sign="(=)" value={r18Fn.subtotal(data)} computed className="f22-field-subtotal" />
        <FieldRow label="Saldo positivo del registro REX antes de imputaciones" code="1493" sign="(-)" value={r18Fn.saldoREXPositivo(data)} computed />
        <FieldRow label="Capital aportado, histórico" code="1494" sign="(-)" value={r18Fn.capitalAportado(data)} computed />
        <FieldRow label="Rentas afectas a IGC o IA (RAI) del ejercicio" code="1500" sign="(=)" value={computed.r18?.rai} computed className="f22-field-total" />
      </div>
    </SectionContainer>
  );
};

export default R18Section;
